<template>
    <!-- Page Content -->
    <div id="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="page-header">
              <i class="fa fa-building" aria-hidden="true"></i> Locais
            </h1>
          </div>
          <!-- /.col-lg-12 -->
        </div>
        <!-- /.row -->
        <div class="row">
          <div class="pull-right">
            <a
              class="btn btn-default"
              @click="
                addButton.seeForm = !addButton.seeForm;
                location = {};
              "
            >
              <span v-if="addButton.seeForm">
                <i class="fa fa-search fa-fw"></i>Buscar
              </span>
              <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
            </a>
            <br />
            <br />
            <br />
          </div>
  
          <div class="col-lg-12">
            <form
              v-if="addButton.seeForm"
              role="form"
              @submit.stop.prevent="send"
            >
              <input v-model="location.id" type="hidden" />
              <div class="form-group">
                <label>Id</label>
                <input v-model="location.id" class="form-control" disabled />
              </div>
              <div class="form-group">
                <label>Nome</label>
                <input v-model="location.name" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Cor</label>
                <input
                  type="color"
                  v-model="location.color"
                  class="form-control"
                  list="presetColors"
                  required
                />
                <datalist id="presetColors">
                  <option>#ffcccc</option>
                  <option>#ffd9cc</option>
                  <option>#ffe6cc</option>
                  <option>#fff2cc</option>
                  <option>#ffffcc</option>
                  <option>#f2ffcc</option>
                  <option>#e6ffcc</option>
                  <option>#d9ffcc</option>
                  <option>#ccffcc</option>
                  <option>#ccffd9</option>
                  <option>#ccffe6</option>
                  <option>#ccfff2</option>
                  <option>#ccffff</option>
                  <option>#ccf2ff</option>
                  <option>#cce6ff</option>
                  <option>#ccd9ff</option>
                  <option>#ccccff</option>
                  <option>#d9ccff</option>
                  <option>#e6ccff</option>
                  <option>#f2ccff</option>
                  <option>#ffccff</option>
                  <option>#ffccf2</option>
                  <option>#ffcce6</option>
                  <option>#ffccd9</option>
                  <option>#ffcccc</option>
                </datalist>
              </div>
              <div class="form-group">
                <label>Latitude</label>
                <input v-model="location.latitude" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Longitude</label>
                <input v-model="location.longitude" class="form-control" required />
              </div>
              <button type="submit" class="btn btn-block btn-info">Salvar</button>
              <br/>
              <div v-if="msg" class="alert alert-danger">
                 <i class="fa fa-exclamation"></i>
                 O campo <strong>Cor</strong> não pode ser nulo 
              </div>
            </form>
            <form v-else>
              <div class="form-group">
                <input
                  v-model="search"
                  class="form-control"
                  placeholder="Buscar..."
                />
              </div>
            </form>
          </div>
        </div>
        <hr />
        <div class="row">
          <div v-if="filtred.length">
            <div class="col-lg-4" v-for="location in filtred" :key="location.id">
              <div class="panel panel-default">
                <div class="panel-heading" :style="locationColor(location.color)">
                  <b
                    data-toggle="tooltip"
                    data-placement="top"
                    v-bind:title="location.name">#{{ location.id }} {{ location.name.substring(0, 30) }}</b>
                  <div class="pull-right">
                    <div class="btn-group" role="group">
                      <a
                        @click.stop="edit(location.id)"
                        class="btn btn-primary btn-sm"
                        ><i class="fa fa-pencil fa-fw"></i
                      ></a>
                      <a
                        @click=" showModal = 1; show = location.id"
                        class="btn btn-sm btn-danger"
                        ><i class="fa fa-trash fa-fw"></i
                      ></a>
                    </div>
                    <br />
                  </div>
                  <br />
                </div>
                <div class="panel-body" :style="locationColor(location.color)">
                  <p>
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    Latitude: {{ location.latitude }}
                  </p>
                  <p>
                    <i class="fa fa-location-arrow" aria-hidden="true"></i>
                    Longitude: {{ location.longitude }}
                  </p>
                </div>
              </div>
              <Modal v-if="showModal === 1 && show === location.id">
                <i
                  slot="close"
                  @click="
                    showModal = null;
                    yes = null;
                  "
                  >&times;</i
                >
                <h2 slot="header"><i class="fa fa-times fa-fw"></i>Remover Local</h2>
                <div slot="body">
                  <h4>Deseja realmente remover o local <strong>{{ location.name }}?</strong></h4>
                </div>
                <div slot="footer">
                  <button
                    type="button" class="btn btn-primary"
                    @click="
                      yes = true;
                      showModal = null;
                    "
                    @click.stop="remove(location.id)"
                  >
                    Confirmar
                  </button>
                  <button
                    class="btn btn-default"
                    @click="
                      yes = null;
                      showModal = null;
                    "
                  >
                    fechar
                  </button>
                </div>
              </Modal>
            </div>
          </div>
          <Modal v-if="showModal === 2">
            <i slot="close" @click="showModal = null">&times;</i>
            <h2 slot="header">
              <i class="fa fa-exclamation-circle fa-fw"></i>Cadastro de Local
            </h2>
            <div slot="body">
              <div
                class="alert alert-success alert-small"
              ><i class="fa fa-exclamation"></i>
                Local cadastrado com sucesso!
              </div>
            </div>
            <div slot="footer">
              <button class="btn btn-default" @click="showModal = null">
                Ok
              </button>
            </div>
          </Modal>
          <Modal v-if="showModal === 3">
            <i slot="close" @click="showModal = null">&times;</i>
            <h2 slot="header">
              <i class="fa fa-times fa-fw"></i>Exclusão de Local
            </h2>
            <div slot="body">
              <div
                class="alert alert-success alert-small"
              ><i class="fa fa-exclamation"></i>
                Local excluído com sucesso!
              </div>
            </div>
            <div slot="footer">
              <button class="btn btn-default" @click="showModal = null">
                Ok
              </button>
            </div>
          </Modal>
          <div v-else-if="!filtred.length">
            <div class="alert alert-info">
              <p>
                <i class="fa fa-exclamation fa-fw"></i>Nenhum registro foi
                encontrado
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </div>
  </template>
  
  <script>
  
  import Modal from "../../components/ui-elements/Modal.vue";
  
  export default {
    name: "Locations",
    inject: ["loading"],
    components: { Modal },
    data() {
      return {
        search: "",
        addButton: { seeForm: false },
        location: {},
        locations: [],
        show: null,
        yes: null,
        showModal: null,
        msg: null,
      };
    },
    mounted() {
      this.loading.value = true;
      this.$http.get("/location").then((response) => {
        this.locations = response.data.content;
      }).finally(() => {
          this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip();
          });
          setTimeout(() => (this.loading.value = false), 1000);
        });
    },
    methods: {
      locationColor(color) {
        if (color) {
          return { backgroundColor: color };
        }
        return "";
      },
      send() {
        this.loading.value = true;
        if (this.location.id) {
          this.$http
            .put(`/location/${this.location.id}`, this.location)
            .then((response) => {
              this.locations = this.locations.filter(
                (item) => item.id != this.location.id
              );
              this.locations.push(response.data);
              this.location = {};
              this.addButton.seeForm = false;
              this.showModal = 2;
              this.msg = null;
            })
            .catch((error) => {
              this.msg = error;
            });
          setTimeout(() => (this.loading.value = false), 1000);
        } else {
          this.$http
            .post("/location", this.location)
            .then((response) => {
              this.location = {};
              this.locations.push(response.data);
              this.addButton.seeForm = false;
              this.showModal = 2;
              this.msg = null;
            })
            .catch((error) => {
              this.msg = error;
            });
          setTimeout(() => (this.loading.value = false), 1000);
        }
      },
      edit(id) {
        this.loading.value = true;
        this.$http
          .get(`/location/${id}`)
          .then((response) => {
            this.addButton.seeForm = true;
            this.location = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
        setTimeout(() => (this.loading.value = false), 1000);
      },
      remove(id) {
        const confirm = this.yes;
  
        if (confirm) {
          this.loading.value = true;
          this.$http
            .delete(`/location/${id}`)
            .then((response) => {
              this.locations = this.locations.filter((item) => item.id != id);
              this.showModal = 3;
            })
            .catch((error) => alert(error));
          setTimeout(() => (this.loading.value = false), 1000);
        }
      },
    },
    computed: {
      filtred() {
        const search = this.search.toLowerCase().trim();
        let result = [];
  
        if (!search) {
          result = this.locations;
        }
  
        result = this.locations.filter(
          (location) => location.name.toLowerCase().indexOf(search) > -1
        );
  
        return result.sort((a, b) => b.id - a.id);
      },
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/pages/Locations.vue